export default function MySQL_YEAR() {
  return (
    <div>
      <h2>MySQL_YEAR</h2>    </div>
  );
}